import React from 'react';
import styles from './Avatar.module.css';
import avatar from '../../assets/images/avatar.png';

const Avatar = () => {
  return (
    <img
      src={avatar}
      alt="Profile Avatar"
      className={styles.avatar}
    />
  );
};

export default Avatar;